module.exports = __webpack_public_path__ + "static/banner-sobre-24daab43f20304ab63b97172a5621c2c.jpg";